import { callAuthAPI } from 'react-morel-auth';

export const getAppUser = (appUserId: string, params: string) => {
  return callAuthAPI('/system/users/' + appUserId, params, {
    method: 'GET',
    headers: {
      Accept: 'application/ld+json',
    },
  });
};
